<div mat-dialog-title class="ds">
  <span>{{ isNewItem ? appStrings.b2bCart_addItem : appStrings.b2bCart_editItem }}</span>
  <button mat-icon-button class="close-dialog-button" mat-dialog-close>
    <mat-icon class="close-icon">close</mat-icon>
  </button>
</div>
<div mat-dialog-content class="content ds">
  <ds-textfield
    id="itemNumberDialogInput"
    class="fill-width no-subscript"
    [label]="appStrings.b2bCart_itemNumber"
    label_orientation="vertical-label"
    [control]="itemNumberControl">
  </ds-textfield>

  <ds-textfield
    id="quantityDialogInput"
    class="half-width no-subscript quantity-input"
    [label]="appStrings.b2bCart_quantity"
    label_orientation="vertical-label"
    [control]="quantityControl"
    [maxLength]="5">
  </ds-textfield>

  <div class="field-group">
    <typography variant="caption-2" weight="regular" class="field-label">
      {{ appStrings.b2bCart_description }}
    </typography>
    <typography variant="caption-1" weight="bold">
      {{ item.Name || '-' }}
    </typography>
  </div>

  <div class="price-row">
    <div class="field-group half-width">
      <typography variant="caption-2" weight="regular" class="field-label">
        {{ appStrings.b2bCart_unitPrice }}
      </typography>
      <typography variant="caption-1" weight="bold">
        {{ currencySymbol }}{{ item.NetPrice || '-' }}
      </typography>
    </div>

    <div class="field-group half-width">
      <typography variant="caption-2" weight="regular" class="field-label">
        {{ appStrings.b2bCart_totalPrice }}
      </typography>
      <typography variant="caption-1" weight="bold">
        {{ currencySymbol }}{{ getTotalPrice() | number:'1.2-2' }}
      </typography>
    </div>
  </div>
</div>
<div mat-dialog-actions align="end" class="ds">
  <div class="dialog-btn-wrapper">
    <ds-button
      id="cancelDialogButton"
      size="medium"
      type="secondary"
      variant="label-only"
      [label]="appStrings.button_cancel"
      (onClick)="cancel()">
    </ds-button>
    <ds-button
      id="saveDialogButton"
      size="medium"
      type="primary"
      variant="label-only"
      [label]="appStrings.button_save"
      (onClick)="save()">
    </ds-button>
  </div>
</div>
